import _defineProperty from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { unit } from '@ant-design/cssinjs';
import { operationUnit } from '../../style';
var genExpandStyle = function genExpandStyle(token) {
  var _$concat2;
  var componentCls = token.componentCls,
    antCls = token.antCls,
    motionDurationSlow = token.motionDurationSlow,
    lineWidth = token.lineWidth,
    paddingXS = token.paddingXS,
    lineType = token.lineType,
    tableBorderColor = token.tableBorderColor,
    tableExpandIconBg = token.tableExpandIconBg,
    tableExpandColumnWidth = token.tableExpandColumnWidth,
    borderRadius = token.borderRadius,
    tablePaddingVertical = token.tablePaddingVertical,
    tablePaddingHorizontal = token.tablePaddingHorizontal,
    tableExpandedRowBg = token.tableExpandedRowBg,
    paddingXXS = token.paddingXXS,
    expandIconMarginTop = token.expandIconMarginTop,
    expandIconSize = token.expandIconSize,
    expandIconHalfInner = token.expandIconHalfInner,
    expandIconScale = token.expandIconScale,
    calc = token.calc;
  var tableBorder = "".concat(unit(lineWidth), " ").concat(lineType, " ").concat(tableBorderColor);
  var expandIconLineOffset = calc(paddingXXS).sub(lineWidth).equal();
  return _defineProperty({}, "".concat(componentCls, "-wrapper"), (_$concat2 = {}, _defineProperty(_$concat2, "".concat(componentCls, "-expand-icon-col"), {
    width: tableExpandColumnWidth
  }), _defineProperty(_$concat2, "".concat(componentCls, "-row-expand-icon-cell"), _defineProperty({
    textAlign: 'center'
  }, "".concat(componentCls, "-row-expand-icon"), {
    display: 'inline-flex',
    float: 'none',
    verticalAlign: 'sub'
  })), _defineProperty(_$concat2, "".concat(componentCls, "-row-indent"), {
    height: 1,
    float: 'left'
  }), _defineProperty(_$concat2, "".concat(componentCls, "-row-expand-icon"), Object.assign(Object.assign({}, operationUnit(token)), {
    position: 'relative',
    float: 'left',
    boxSizing: 'border-box',
    width: expandIconSize,
    height: expandIconSize,
    padding: 0,
    color: 'inherit',
    lineHeight: unit(expandIconSize),
    background: tableExpandIconBg,
    border: tableBorder,
    borderRadius: borderRadius,
    transform: "scale(".concat(expandIconScale, ")"),
    transition: "all ".concat(motionDurationSlow),
    userSelect: 'none',
    '&:focus, &:hover, &:active': {
      borderColor: 'currentcolor'
    },
    '&::before, &::after': {
      position: 'absolute',
      background: 'currentcolor',
      transition: "transform ".concat(motionDurationSlow, " ease-out"),
      content: '""'
    },
    '&::before': {
      top: expandIconHalfInner,
      insetInlineEnd: expandIconLineOffset,
      insetInlineStart: expandIconLineOffset,
      height: lineWidth
    },
    '&::after': {
      top: expandIconLineOffset,
      bottom: expandIconLineOffset,
      insetInlineStart: expandIconHalfInner,
      width: lineWidth,
      transform: 'rotate(90deg)'
    },
    // Motion effect
    '&-collapsed::before': {
      transform: 'rotate(-180deg)'
    },
    '&-collapsed::after': {
      transform: 'rotate(0deg)'
    },
    '&-spaced': {
      '&::before, &::after': {
        display: 'none',
        content: 'none'
      },
      background: 'transparent',
      border: 0,
      visibility: 'hidden'
    }
  })), _defineProperty(_$concat2, "".concat(componentCls, "-row-indent + ").concat(componentCls, "-row-expand-icon"), {
    marginTop: expandIconMarginTop,
    marginInlineEnd: paddingXS
  }), _defineProperty(_$concat2, "tr".concat(componentCls, "-expanded-row"), _defineProperty({
    '&, &:hover': {
      '> th, > td': {
        background: tableExpandedRowBg
      }
    }
  }, "".concat(antCls, "-descriptions-view"), {
    display: 'flex',
    table: {
      flex: 'auto',
      width: '100%'
    }
  })), _defineProperty(_$concat2, "".concat(componentCls, "-expanded-row-fixed"), {
    position: 'relative',
    margin: "".concat(unit(calc(tablePaddingVertical).mul(-1).equal()), " ").concat(unit(calc(tablePaddingHorizontal).mul(-1).equal())),
    padding: "".concat(unit(tablePaddingVertical), " ").concat(unit(tablePaddingHorizontal))
  }), _$concat2));
};
export default genExpandStyle;